import React from 'react';
import { Menu, Search, Bell } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../hooks/useTheme';

interface HeaderProps {
  onMenuClick: () => void;
}

const Header: React.FC<HeaderProps> = ({ onMenuClick }) => {
  const { user } = useAuth();
  const { colors } = useTheme();

  return (
    <header 
      className="sticky top-0 z-30 border-b px-4 py-3 lg:px-6 transition-colors duration-300"
      style={{ 
        backgroundColor: colors.mantle,
        borderColor: colors.surface0,
        color: colors.text
      }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-lg hover:opacity-80 transition-all duration-200"
            style={{ backgroundColor: colors.surface0, color: colors.text }}
          >
            <Menu className="w-5 h-5" />
          </button>
          
          <div className="relative hidden sm:block">
            <Search 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4"
              style={{ color: colors.subtext0 }}
            />
            <input
              type="text"
              placeholder="Search notes, projects..."
              className="pl-10 pr-4 py-2 rounded-lg border focus:outline-none focus:ring-2 transition-all duration-200"
              style={{
                backgroundColor: colors.surface0,
                borderColor: colors.surface1,
                color: colors.text
              }}
            />
          </div>
        </div>

        <div className="flex items-center gap-4">
          <button 
            className="p-2 rounded-lg hover:opacity-80 transition-all duration-200 relative"
            style={{ backgroundColor: colors.surface0, color: colors.text }}
          >
            <Bell className="w-5 h-5" />
            <span 
              className="absolute -top-1 -right-1 w-3 h-3 rounded-full text-xs flex items-center justify-center"
              style={{ backgroundColor: colors.red }}
            >
              <span className="w-2 h-2 rounded-full bg-white"></span>
            </span>
          </button>
          
          <div className="flex items-center gap-3">
            <div 
              className="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium text-white"
              style={{ backgroundColor: colors.blue }}
            >
              {user?.name?.[0]?.toUpperCase() || 'U'}
            </div>
            <span 
              className="hidden md:block text-sm font-medium"
              style={{ color: colors.text }}
            >
              {user?.name}
            </span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;